import React from "react";
import { AppShell } from "@/components/AppShell";
import { Card, CardContent } from "@/components/ui/card";
import { Wrench } from "lucide-react";

export default function Placeholder({ title, subtitle, section }) {
  return (
    <AppShell>
      <div className="mb-8">
        {section && <div className="text-xs tracking-[0.18em] uppercase text-muted-foreground">{section}</div>}
        <h1 className="font-heading font-bold text-3xl sm:text-4xl mt-1">{title}</h1>
        <p className="text-sm text-muted-foreground mt-2 max-w-xl">{subtitle}</p>
      </div>
      <Card className="border-dashed border-border">
        <CardContent className="p-12 text-center">
          <div className="h-14 w-14 mx-auto rounded-full bg-primary/10 text-primary flex items-center justify-center mb-4">
            <Wrench className="h-6 w-6" />
          </div>
          <div className="font-heading font-bold text-lg text-foreground">Modul Sedang Dikembangkan</div>
          <p className="text-sm text-muted-foreground mt-2 max-w-md mx-auto">
            Modul ini akan dibangun pada fase berikutnya. Fondasi database, RBAC, dan alur workflow sudah tersedia — implementasi UI akan menyusul.
          </p>
        </CardContent>
      </Card>
    </AppShell>
  );
}
